// account-details.resolver.ts
import { Injectable } from '@angular/core';
import { Resolve, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PortalService } from './portal.service';

@Injectable({
  providedIn: 'root'
})
export class AccountDetailsResolver implements Resolve<any> {
  programId?: number;
  emailID: any;
  patientAccountId: any;

  constructor(private portalService: PortalService, private router: Router) {}

  resolve(): Observable<boolean> | boolean {
    this.emailID = localStorage.getItem('email');
    this.patientAccountId = localStorage.getItem('patientAccountId');  

    if(this.patientAccountId) return true;
    return this.portalService.getPatientAccountDetail(this.emailID).pipe(
      map((response: any) => { 
        if (response.patientAccountId) {
          localStorage.setItem('patientAccountId', response.patientAccountId.toString());
          console.log('Patient Account ID found:', response.patientAccountId);
          return true;
        } else {
          console.warn('Patient Account ID not found. Redirecting to UserProfile.');
          this.router.navigate(['/UserProfile']);
          return false;
        }
      }),
      catchError((error) => {
        console.error('Error fetching patient account details:', error);
        this.router.navigate(['/userProfile']);
        return of(false);
      })
    );
  }
}